export enum TransportLabels {
    CAR = "Samochód",
    PUBLIC_TRANSPORT = "Komunikacja"
}
export enum TransportLabels {
    CAR = "Samochód",
    PUBLIC_TRANSPORT = "Komunikacja"
}
